
import React, { useState, useEffect, useRef } from 'react';
import {
  Box,
  Drawer,
  IconButton,
  Typography,
  TextField,
  Stack,
  Avatar,
  Tooltip,
  Paper,
  Divider,
  Button,
  useTheme,
  Dialog,
  DialogContent,
  Zoom,
  Fade,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  InputBase,
  ClickAwayListener,
  Grid,
  Menu,
  MenuItem,
  CircularProgress,
} from '@material-ui/core';
import {
  Close,
  Fullscreen,
  FullscreenExit,
  Send,
  Android,
  Person,
  Add,
  History,
  Settings,
  MoreVert,
  DeleteOutline,
  Edit,
  ChevronLeft,
  ChevronRight,
  KeyboardArrowDown,
  AutoAwesome,
  Image,
  Create,
  Search,
  AddCircleOutline,
  Mic,
  ArrowUpward,
  Language,
  TrackChanges,
  Brightness4,
  Brightness7,
  Forum,
  GraphicEq,
  Face,
  LockOutlined,
  Check,
  AttachFile,
  Explore,
  MoreHoriz,
  FolderOpen,
  Restore,
  VisibilityOff,
  Memory,
  Schema,
  CropSquare,
  CropPortrait,
  StayCurrentPortrait,
  CropLandscape,
  Crop75,
  TrendingUp,
  RadioButtonUnchecked,
  ChatBubbleOutline,
} from '@material-ui/icons';


import { motion, AnimatePresence } from 'framer-motion';
import Lottie from 'lottie-react';
import robotIcon from 'src/assets/Ai Robot Vector Art.json';
import axios from 'axios';
import { REST_API } from 'src/constants/DefaultValues';

const getSefiUserId = () => {
  const fromStorage = localStorage.getItem('user_id');
  if (fromStorage && fromStorage !== 'null') return fromStorage;
  try {
    const u = JSON.parse(localStorage.getItem('user') || '{}');
    return u?.user_id ?? u?.id ?? null;
  } catch {
    return null;
  }
};

const sefiAuthHeaders = () => {
  const token = localStorage.getItem('accessToken');
  if (!token || token === 'null' || token === 'undefined') return {};
  return { Authorization: `Bearer ${token}` };
};

/** JWT + user_id query (same pattern as other ticket APIs). */
const sefiRequestConfig = () => {
  const userId = getSefiUserId();
  return {
    headers: sefiAuthHeaders(),
    params: userId ? { user_id: userId } : {},
  };
};

const mapApiMessage = (m) => ({
  id: m.id,
  role: m.role === 'assistant' ? 'ai' : m.role,
  content: m.content || '',
  timestamp: m.created_at ? new Date(m.created_at * 1000) : new Date(),
});

// ----------------------------------------------------------------------

const TemporaryChatIcon = ({ size = 20, active = false, ...other }) => (
  <Box 
    component="span" 
    className={active ? 'ai--temporary-chat-active' : 'ai--temporary-chat'} 
    sx={{ width: size, height: size, color: 'inherit', ...other.sx }} 
  />
);

const NoTrainingIcon = ({ size = 20, ...other }) => (
  <Box 
    component="span" 
    className="ai--no-training" 
    sx={{ width: size, height: size, color: 'inherit', ...other.sx }} 
  />
);

const MemoryOffIcon = ({ size = 20, ...other }) => (
  <Box 
    component="span" 
    className="ai--memory-off" 
    sx={{ width: size, height: size, color: 'inherit', ...other.sx }} 
  />
);

const VoiceWaveIcon = ({ size = 20, color = 'white' }) => (
  <Box 
    component="span" 
    className="ai--voice-wave" 
    sx={{ 
      width: size, 
      height: size, 
      color: color,
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center'
    }} 
  />
);


const CHAT_GPT_BLUE = '#10a37f';
const CHAT_GPT_DARK = '#202123';
const CHAT_GPT_LIGHT_DARK = '#343541';
const CHAT_GPT_AI_BG = '#444654';
const MOBILE_BG = '#ffffff';

const SUGGESTIONS = [
  { icon: <Image fontSize="small" />, text: 'Create an image' },
  { icon: <Edit fontSize="small" />, text: 'Write or edit' },
  { icon: <Language fontSize="small" />, text: 'Look something up' },

];


export default function AiChatbot({ open, onClose }) {
  const theme = useTheme();
  const user = JSON.parse(localStorage.getItem('user')) || {};
  const [maximized, setMaximized] = useState(false);
  const [desktopSidebarOpen, setDesktopSidebarOpen] = useState(true);
  const [historySearchQuery, setHistorySearchQuery] = useState('');
  const [searchDialogOpen, setSearchDialogOpen] = useState(false);
  const [searchModalQuery, setSearchModalQuery] = useState('');
  const [recentsAnchor, setRecentsAnchor] = useState(null);
  const [isSelectingFile, setIsSelectingFile] = useState(false);
  const [isTemporary, setIsTemporary] = useState(false);
  const [isImageMode, setIsImageMode] = useState(false);
  const [isWriteMode, setIsWriteMode] = useState(false);
  const [isSearchMode, setIsSearchMode] = useState(false);
  const [hoverSearch, setHoverSearch] = useState(false);
  const [hoverImage, setHoverImage] = useState(false);
  const [aspectRatioAnchor, setAspectRatioAnchor] = useState(null);
  const [selectedRatio, setSelectedRatio] = useState('Auto');
  const [modelAnchor, setModelAnchor] = useState(null);
  const [selectedModel, setSelectedModel] = useState('Thinking');
  const [input, setInput] = useState('');
  const [plusAnchor, setPlusAnchor] = useState(null);
  const [recentFilesAnchor, setRecentFilesAnchor] = useState(null);
  const [sendMessage, setSendMessage] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);
  
  const recentFiles = [
    { name: 'Project_Design.png', url: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&q=80&w=200' },
    { name: 'User_Profile.jpg', url: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?auto=format&fit=crop&q=80&w=200' },
    { name: 'Analytics_Report.pdf', url: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&q=80&w=200' }
  ];
  const exploreScrollRefMobile = useRef(null);
  const exploreScrollRefDesktop = useRef(null);
  const fileInputRef = useRef(null);
  // const [showVoiceOnboarding, setShowVoiceOnboarding] = useState(false);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    files.forEach(file => {
      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = (ev) => {
          setSelectedFiles(prev => [...prev, {
            id: Date.now() + Math.random(),
            url: ev.target.result,
            name: file.name,
            type: file.type
          }]);
        };
        reader.readAsDataURL(file);
      } else {
        setSelectedFiles(prev => [...prev, {
          id: Date.now() + Math.random(),
          url: null,
          name: file.name,
          type: file.type
        }]);
      }
    });
    // Delay resetting so ClickAway doesn't catch the focus return
    setTimeout(() => setIsSelectingFile(false), 500);
  };

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);
  const [messages, setMessages] = useState([]);
  const [currentChatId, setCurrentChatId] = useState(null);
  const [history, setHistory] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [loadingChatId, setLoadingChatId] = useState(null);
  const forceNewSessionRef = useRef(false);

  const [showVoiceOnboarding, setShowVoiceOnboarding] = useState(false);
  const [hasSeenVoiceOnboarding, setHasSeenVoiceOnboarding] = useState(() => {
    return localStorage.getItem('hasSeenVoiceOnboarding') === 'true';
  });

  const [showTemporaryOnboarding, setShowTemporaryOnboarding] = useState(false);
  const [hasSeenTemporaryOnboarding, setHasSeenTemporaryOnboarding] = useState(() => {
    return localStorage.getItem('hasSeenTemporaryOnboarding') === 'true';
  });

  useEffect(() => {
    setIsDarkMode(maximized);
  }, [maximized]);

  const scrollRef = useRef(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [messages, open]);

  const fetchChatSessions = async () => {
    try {
      setHistoryLoading(true);
      const response = await axios.get(`${REST_API}ai/sessions`, sefiRequestConfig());
      if (response?.data?.success && Array.isArray(response.data.sessions)) {
        setHistory(
          response.data.sessions.map((s) => ({
            id: s.id,
            title: s.title || 'New chat',
            messages: [],
          }))
        );
      }
    } catch (err) {
      console.error('Failed to load chat sessions:', err);
    } finally {
      setHistoryLoading(false);
    }
  };

  const handleLoadChat = async (chat) => {
    if (!chat?.id) return;
    setCurrentChatId(chat.id);
    forceNewSessionRef.current = false;
    setIsImageMode(false);
    setIsWriteMode(false);
    setIsSearchMode(false);
    setSelectedFiles([]);
    setInput('');
    setDrawerOpen(false);

    if (chat.messages?.length) {
      setMessages(chat.messages);
      return;
    }

    try {
      setLoadingChatId(chat.id);
      const response = await axios.get(
        `${REST_API}ai/sessions/${chat.id}/messages`,
        sefiRequestConfig()
      );
      const loaded = (response?.data?.messages || []).map(mapApiMessage);
      setMessages(loaded);
      setHistory((prev) =>
        prev.map((item) =>
          item.id === chat.id ? { ...item, messages: loaded } : item
        )
      );
    } catch (err) {
      console.error('Failed to load chat messages:', err);
      setMessages([]);
    } finally {
      setLoadingChatId(null);
    }
  };

  const handleNewChat = () => {
    forceNewSessionRef.current = true;
    setCurrentChatId(null);
    setMessages([]);
    setIsImageMode(false);
    setIsWriteMode(false);
    setIsSearchMode(false);
    setSelectedFiles([]);
    setInput('');
    setDrawerOpen(false);
  };

  useEffect(() => {
    if (open) {
      fetchChatSessions();
    } else {
      forceNewSessionRef.current = false;
      setCurrentChatId(null);
      setMessages([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  const handleSend = async () => {
    const trimmedInput = input.trim();
    if (!trimmedInput && selectedFiles.length === 0) return;

    const userMessage = {
      id: Date.now(),
      role: 'user',
      content: trimmedInput,
      files: selectedFiles,
      aspectRatio: selectedRatio,
      timestamp: new Date(),
    };

    try {
      setSendMessage(true);
      setMessages((prev) => [...prev, userMessage]);
      setInput('');
      setSelectedImage(null);
      setSelectedFiles([]);

      const conversation_history = [...messages, userMessage]
        .slice(-8)
        .map((m) => ({
          role: m.role === 'ai' ? 'assistant' : 'user',
          content: m.content || '',
        }));

      const userId = getSefiUserId();
      const response = await axios.post(
        `${REST_API}ai/chat`,
        {
          message: trimmedInput,
          conversation_history,
          session_id: currentChatId || undefined,
          new_session: forceNewSessionRef.current,
          is_temporary: isTemporary,
          user_id: userId || undefined,
        },
        sefiRequestConfig()
      );

      const answerText =
        response?.data?.answer ||
        response?.data?.ai_response ||
        (response?.data?.success === false
          ? 'The AI service could not answer right now. Check that the Python backend is running on port 8000.'
          : null);

      const aiMessage = {
        id: Date.now() + 1,
        role: 'ai',
        content:
          answerText ||
          `I've received your request about: "${trimmedInput}". How can I help you further?`,
        timestamp: new Date(),
      };
      setMessages((prev) => [...prev, aiMessage]);

      const sessionId = response?.data?.session_id;
      if (sessionId && !isTemporary) {
        forceNewSessionRef.current = false;
        setCurrentChatId(sessionId);
        await fetchChatSessions();
      }

      // setTimeout(() => {
      //   const aiMessage = {
      //     id: Date.now() + 1,
      //     role: 'ai',
      //     content: `I've received your request about: "${input}". How can I help you further?`,
      //     timestamp: new Date(),
      //   };
      //   setMessages((prev) => [...prev, aiMessage]);
      // }, 1000);
    }catch(error){
      setSendMessage(false);
      console.error("Error sending message:", error);
      const aiMessage = {
        id: Date.now() + 1,
        role: 'ai',
        content: `Sorry, I couldn't process your request right now. Please try again later.`,
        timestamp: new Date(),
      };
      setMessages((prev) => [...prev, aiMessage]);
    }finally {
      setInput('');
      setSelectedFiles([]);
      setSendMessage(false);
    }
  };

  const handleMicClick = () => {
    if (!hasSeenVoiceOnboarding) {
      setShowVoiceOnboarding(true);
    } else {
      // Start voice logic here
      console.log("Voice started");
    }
  };

  const handleContinueVoice = () => {
    setHasSeenVoiceOnboarding(true);
    setShowVoiceOnboarding(false);
    localStorage.setItem('hasSeenVoiceOnboarding', 'true');
    // Start voice logic here
  };

  const handleTemporaryToggle = () => {
    if (!isTemporary && !hasSeenTemporaryOnboarding) {
      setShowTemporaryOnboarding(true);
    } else {
      setIsTemporary(!isTemporary);
    }
  };

  const handleContinueTemporary = () => {
    setHasSeenTemporaryOnboarding(true);
    setShowTemporaryOnboarding(false);
    localStorage.setItem('hasSeenTemporaryOnboarding', 'true');
    setIsTemporary(true);
  };

  const handleToggleMaximize = () => {
    setMaximized(!maximized);
  };

  const renderMessage = (msg) => {
    const isAi = msg.role === 'ai';
    return (
      <Box
        key={msg.id}
        sx={{
          py: 2,
          px: maximized ? { xs: 2, md: 10 } : 2,
          display: 'flex',
          flexDirection: isAi ? 'row' : 'row-reverse',
          gap: 1.5,
          width: '100%',
          alignItems: 'flex-start'
        }}
      >
        <Box sx={{ width: 32, height: 32, flexShrink: 0, mt: 0.5 }}>
          {isAi ? (
            <Lottie animationData={robotIcon} loop={true} />
          ) : (
            <Avatar
              sx={{
                bgcolor: theme.palette.secondary.main,
                width: 32,
                height: 32,
              }}
            >
              <Person fontSize="small" />
            </Avatar>
          )}
        </Box>

        <Box sx={{ 
          maxWidth: '75%', 
          display: 'flex', 
          flexDirection: 'column', 
          alignItems: isAi ? 'flex-start' : 'flex-end' 
        }}>
          {msg.files && msg.files.length > 0 && (
            <Box sx={{ 
              display: 'flex', 
              flexWrap: 'wrap', 
              gap: 1, 
              mb: 1, 
              width: '100%',
              justifyContent: isAi ? 'flex-start' : 'flex-end'
            }}>
              {msg.files.map((file, fIdx) => (
                file.url ? (
                  <Box 
                    key={fIdx}
                    component="img" 
                    src={file.url} 
                    onClick={() => setPreviewImage(file.url)}
                    sx={{ 
                      maxWidth: msg.files.length > 1 ? 140 : 240, 
                      maxHeight: msg.files.length > 1 ? 140 : 240, 
                      borderRadius: '12px', 
                      boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                      border: isDarkMode ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(0,0,0,0.05)',
                      cursor: 'pointer',
                      transition: 'transform 0.2s',
                      '&:hover': { transform: 'scale(1.02)' }
                    }} 
                  />
                ) : (
                  <Box 
                    key={fIdx}
                    sx={{ 
                      p: 1.5, 
                      bgcolor: isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)', 
                      borderRadius: '12px',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      border: `1px solid ${isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}`
                    }}
                  >
                    <AttachFile sx={{ fontSize: 18 }} />
                    <Typography variant="caption" sx={{ fontWeight: 600 }}>{file.name}</Typography>
                  </Box>
                )
              ))}
            </Box>
          )}
          <Box sx={{
            bgcolor: isDarkMode ? '#2f2f2f' : '#f4f4f4',
            color: isDarkMode ? '#ececf1' : '#374151',
            p: 1.5,
            px: 2,
            borderRadius: isAi ? '4px 20px 20px 20px' : '20px 20px 4px 20px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.05)',
            transition: 'all 0.2s'
          }}>
            <Typography
              variant="body1"
              sx={{
                lineHeight: 1.5,
                whiteSpace: 'pre-wrap',
                fontSize: '0.92rem'
              }}
            >
              {msg.content}
            </Typography>
          </Box>
        </Box>
      </Box>
    );
  };

  const SidebarContent = (
    <Box sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column', bgcolor: isDarkMode ? CHAT_GPT_LIGHT_DARK : '#ffffff' }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <Button
          variant="text"
          startIcon={<Edit fontSize="small" />}
          fullWidth
          onClick={handleNewChat}
          sx={{
            justifyContent: 'flex-start',
            color: isDarkMode ? 'white' : 'black',
            borderRadius: '10px',
            py: 1,
            px: 1.5,
            textTransform: 'none',
            '&:hover': { bgcolor: isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)' }
          }}
        >
          New chat
        </Button>
        {maximized && (
          <Tooltip title="Close sidebar" arrow>
            <IconButton 
              size="small" 
              onClick={() => setDesktopSidebarOpen(false)} 
              sx={{ color: isDarkMode ? 'rgba(255,255,255,0.6)' : 'gray', p: 1, borderRadius: '8px' }}
            >
              <Box sx={{ 
                width: 18, 
                height: 18, 
                border: `2px solid currentColor`, 
                borderRadius: '3px',
                position: 'relative',
                '&::after': {
                  content: '""',
                  position: 'absolute',
                  left: 5,
                  top: 0,
                  bottom: 0,
                  width: '2px',
                  bgcolor: 'currentColor'
                }
              }} />
            </IconButton>
          </Tooltip>
        )}
      </Box>

      <Button
        variant="text"
        startIcon={<Search fontSize="small" sx={{ opacity: 0.7 }} />}
        fullWidth
        onClick={() => setSearchDialogOpen(true)}
        sx={{
          justifyContent: 'flex-start',
          color: isDarkMode ? 'white' : 'black',
          mb: 1,
          borderRadius: '10px',
          py: 1,
          px: 1.5,
          textTransform: 'none',
          fontWeight: 400,
          '&:hover': { bgcolor: isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)' }
        }}
      >
        Search chats
      </Button>

      <Stack spacing={0.5} sx={{ flex: 1, overflowY: 'auto', mt: 1 }}>
        <Typography variant="caption" sx={{ color: 'gray', px: 1, mb: 1 }}>Recents</Typography>
        {historyLoading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
            <CircularProgress size={22} />
          </Box>
        )}
        {!historyLoading && history
          .filter(item => item.title.toLowerCase().includes(historySearchQuery.toLowerCase()))
          .map((item) => (
            <Box
              key={item.id}
              onClick={() => handleLoadChat(item)}
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                px: 1.5,
                py: 1,
                borderRadius: '10px',
                cursor: 'pointer',
                transition: 'all 0.15s',
                color: isDarkMode ? 'rgba(255,255,255,0.9)' : 'rgba(0,0,0,0.8)',
                bgcolor: currentChatId === item.id ? (isDarkMode ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.04)') : 'transparent',
                '&:hover': { bgcolor: isDarkMode ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.04)' }
              }}
            >
              <ChatBubbleOutline sx={{ fontSize: 18, color: isDarkMode ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.3)' }} />
              <Typography sx={{ fontSize: '0.85rem', fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>
                {item.title}
              </Typography>
              {loadingChatId === item.id && (
                <CircularProgress size={14} sx={{ flexShrink: 0 }} />
              )}
            </Box>
          ))}
        {!historyLoading && history.filter(item => item.title.toLowerCase().includes(historySearchQuery.toLowerCase())).length === 0 && (
          <Typography sx={{ color: 'gray', px: 1.5, py: 1, fontSize: '0.8rem' }}>No chats yet</Typography>
        )}
      </Stack>

      <Divider sx={{ my: 2 }} />
      <ListItem button sx={{ borderRadius: '8px' }}>
        <ListItemIcon sx={{ minWidth: 12 }}>
          {user?.profile_pic ? (
            <Avatar src={user.profile_pic} alt={user.person_name} sx={{ width: 28, height: 28 }} />
          ) : (
            <Avatar sx={{ width: 28, height: 28 }}>{user?.person_name?.charAt(0)}</Avatar>
          )}
        </ListItemIcon>
        <ListItemText 
          primary={user?.person_name || 'User'} 
          secondary={user?.email || ''}
          primaryTypographyProps={{ variant: 'body2', color: isDarkMode ? 'white' : 'black', noWrap: true }} 
          secondaryTypographyProps={{ variant: 'caption', color: isDarkMode ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.6)', noWrap: true }}
        />
      </ListItem>
    </Box>
  );

  const SidebarSlim = (
    <Box sx={{ 
      width: 60, 
      height: '100%', 
      display: { xs: 'none', md: 'flex' }, 
      flexDirection: 'column', 
      alignItems: 'center', 
      py: 2,
      gap: 2,
      bgcolor: isDarkMode ? CHAT_GPT_LIGHT_DARK : '#ffffff',
      borderRight: `1px solid ${isDarkMode ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.05)'}`,
      zIndex: 10
    }}>
      <Tooltip title="Open sidebar" arrow placement="right">
        <IconButton 
          size="small" 
          onClick={() => setDesktopSidebarOpen(true)} 
          sx={{ color: isDarkMode ? 'rgba(255,255,255,0.6)' : 'gray', p: 1, borderRadius: '8px' }}
        >
          <Box sx={{ 
            width: 18, 
            height: 18, 
            border: `2px solid currentColor`, 
            borderRadius: '3px',
            position: 'relative',
            '&::after': {
              content: '""',
              position: 'absolute',
              left: 5,
              top: 0,
              bottom: 0,
              width: '2px',
              bgcolor: 'currentColor'
            }
          }} />
        </IconButton>
      </Tooltip>


      <Tooltip title="New chat" arrow placement="right">
        <IconButton size="small" onClick={handleNewChat} sx={{ color: isDarkMode ? 'white' : 'black', p: 1.2, '&:hover': { bgcolor: isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' } }}>
          <Edit fontSize="small" />
        </IconButton>
      </Tooltip>

      <Tooltip title="Search chats" arrow placement="right">
        <IconButton size="small" onClick={() => setSearchDialogOpen(true)} sx={{ color: isDarkMode ? 'white' : 'black', p: 1.2, '&:hover': { bgcolor: isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' } }}>
          <Search fontSize="small" />
        </IconButton>
      </Tooltip>

      <Tooltip title="Recents" arrow placement="right">
        <IconButton 
          size="small" 
          onClick={(e) => setRecentsAnchor(e.currentTarget)} 
          sx={{ 
            color: isDarkMode ? 'white' : 'black', 
            p: 1.2, 
            bgcolor: Boolean(recentsAnchor) ? (isDarkMode ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.04)') : 'transparent',
            '&:hover': { bgcolor: isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' } 
          }}
        >
          <ChatBubbleOutline fontSize="small" />
        </IconButton>
      </Tooltip>

      <Menu
        anchorEl={recentsAnchor}
        open={Boolean(recentsAnchor)}
        onClose={() => setRecentsAnchor(null)}
        anchorOrigin={{ vertical: 'center', horizontal: 'right' }}
        transformOrigin={{ vertical: 'center', horizontal: 'left' }}
        PaperProps={{
          sx: {
            ml: 1,
            mt: 0,
            borderRadius: '16px',
            bgcolor: isDarkMode ? '#2f2f2f' : '#ffffff',
            border: `1px solid ${isDarkMode ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.05)'}`,
            boxShadow: '0 12px 32px rgba(0,0,0,0.15)',
            width: 280,
            maxHeight: 400,
            overflowY: 'auto',
            backgroundImage: 'none',
            p: 1,
            '& .MuiList-root': { p: 0 }
          }
        }}
      >
        <Box sx={{ px: 2, py: 1.5 }}>
          <Typography variant="caption" sx={{ color: 'gray', fontWeight: 600, display: 'block', mb: 1 }}>Recents</Typography>
          <Stack spacing={0.5}>
            {historyLoading && (
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
                <CircularProgress size={22} />
              </Box>
            )}
            {!historyLoading && history.map((item) => (
              <Box
                key={item.id}
                onClick={() => {
                  handleLoadChat(item);
                  setRecentsAnchor(null);
                }}
                sx={{
                  px: 1.5,
                  py: 1,
                  borderRadius: '10px',
                  cursor: 'pointer',
                  transition: 'all 0.15s',
                  color: isDarkMode ? 'rgba(255,255,255,0.9)' : 'rgba(0,0,0,0.8)',
                  bgcolor: currentChatId === item.id ? (isDarkMode ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.04)') : 'transparent',
                  '&:hover': { bgcolor: isDarkMode ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.02)' }
                }}
              >
                <Typography sx={{ fontSize: '0.85rem', fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {item.title}
                </Typography>
              </Box>
            ))}
            {!historyLoading && history.length === 0 && (
              <Typography sx={{ color: 'gray', fontSize: '0.8rem', px: 1 }}>No chats yet</Typography>
            )}
          </Stack>
        </Box>
      </Menu>

      <Box sx={{ flex: 1 }} />

      <Divider sx={{ width: '60%', my: 1 }} />
    </Box>
  );

  const MobileHeader = (
    <Box sx={{
      p: 1,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      bgcolor: isDarkMode ? CHAT_GPT_LIGHT_DARK : '#ffffff',
      position: 'relative',
      borderBottom: `1px solid ${isDarkMode ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.05)'}`,
      transition: 'background-color 0.3s'
    }}>
      {/* <Tooltip title="Main Menu" arrow> */}
      <IconButton size="small" onClick={() => setDrawerOpen(!drawerOpen)} sx={{ p: 1, position: 'absolute', left: 8 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: '4px', alignItems: 'flex-start' }}>
          <Box sx={{ width: 18, height: 2, bgcolor: isDarkMode ? '#fff' : '#000', borderRadius: 1 }} />
          <Box sx={{ width: 12, height: 2, bgcolor: isDarkMode ? '#fff' : '#000', borderRadius: 1 }} />
        </Box>
      </IconButton>
      {/* </Tooltip> */}
      <Stack direction="row" alignItems="center" spacing={0.5}>
        <Box sx={{ width: 24, height: 24 }}><Lottie animationData={robotIcon} loop={true} /></Box>
        <Typography variant="subtitle2" fontWeight="bold" sx={{ color: isDarkMode ? 'white' : 'black' }}>SEFI</Typography>
        {/* <KeyboardArrowDown fontSize="small" sx={{ color: isDarkMode ? 'white' : 'black' }} /> */}
      </Stack>
      <Box sx={{ position: 'absolute', right: 8, top: '50%', transform: 'translateY(-50%)', display: 'flex', alignItems: 'center', gap: 0.5 }}>
        <Tooltip title={isDarkMode ? "Light Mode" : "Dark Mode"} arrow>
          <IconButton size="small" onClick={() => setIsDarkMode(!isDarkMode)} sx={{ color: isDarkMode ? 'white' : 'gray' }}>
            {isDarkMode ? <Brightness7 fontSize="small" /> : <Brightness4 fontSize="small" />}
          </IconButton>
        </Tooltip>
        {messages.length === 0 && (
          <Tooltip title={isTemporary ? "Turn off temporary chat" : "Turn on temporary chat"} arrow>
            <IconButton 
              size="small" 
              onClick={handleTemporaryToggle}
              sx={{ 
                color: isDarkMode ? 'white' : 'gray',
                bgcolor: 'transparent'
              }}
            >
              <TemporaryChatIcon size={18} active={isTemporary} />
            </IconButton>
          </Tooltip>
        )}
        {!maximized && (
          <Tooltip title="Maximize" arrow>
            <IconButton
              size="small"
              onClick={handleToggleMaximize}
              sx={{ color: 'gray' }}
            >
              <Fullscreen fontSize="small" />
            </IconButton>
          </Tooltip>
        )}
      </Box>
    </Box>
  );


  const DesktopHeader = (
    <Box sx={{
      p: 2,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      bgcolor: isDarkMode ? CHAT_GPT_LIGHT_DARK : '#ffffff',
      borderBottom: `1px solid ${isDarkMode ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.05)'}`,
      transition: 'background-color 0.3s'
    }}>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Box sx={{ width: 30, height: 30 }}><Lottie animationData={robotIcon} loop={true} /></Box>
        <Typography variant="subtitle1" fontWeight="bold" sx={{ color: isDarkMode ? 'white' : 'black' }}>SEFI</Typography>
      </Stack>
      <Stack direction="row" spacing={1}>
        <Tooltip title={isDarkMode ? "Light Mode" : "Dark Mode"} arrow>
          <IconButton size="small" onClick={() => setIsDarkMode(!isDarkMode)} sx={{ color: isDarkMode ? 'white' : 'gray' }}>
            {isDarkMode ? <Brightness7 /> : <Brightness4 />}
          </IconButton>
        </Tooltip>
        {messages.length === 0 && (
          <Tooltip title={isTemporary ? "Turn off temporary chat" : "Turn on temporary chat"} arrow>
            <IconButton 
              size="small" 
              onClick={handleTemporaryToggle}
              sx={{ color: isDarkMode ? 'white' : 'gray' }}
            >
              <TemporaryChatIcon size={20} active={isTemporary} />
            </IconButton>
          </Tooltip>
        )}
        <Tooltip title="Exit Fullscreen" arrow>
          <IconButton size="small" onClick={handleToggleMaximize} sx={{ color: isDarkMode ? 'white' : 'gray' }}><FullscreenExit /></IconButton>
        </Tooltip>
      </Stack>
    </Box>
  );

  const VoiceOnboarding = (
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        zIndex: 200,
        bgcolor: isDarkMode ? CHAT_GPT_DARK : '#ffffff',
        display: 'flex',
        flexDirection: 'column',
        p: 3,
        overflowY: 'auto'
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 4 }}>
        <IconButton onClick={() => setShowVoiceOnboarding(false)} size="small" sx={{ color: isDarkMode ? 'white' : 'black' }}>
          <Close />
        </IconButton>
      </Box>

      <Typography variant="h5" fontWeight="bold" align="center" sx={{ mb: 5, color: isDarkMode ? 'white' : 'black' }}>
        Say hello to Voice
      </Typography>

      <Stack spacing={4} sx={{ flex: 1, px: 1 }}>
        {[
          {
            icon: <Forum style={{ color: isDarkMode ? '#10a37f' : '#10a37f' }} />,
            title: 'Natural conversations',
            desc: 'Senses and responds to interruptions, humor, and more.'
          },
          {
            icon: <GraphicEq style={{ color: isDarkMode ? '#10a37f' : '#10a37f' }} />,
            title: 'Multiple voices',
            desc: 'Offers an expanded set of voices to choose from.'
          },
          {
            icon: <Face style={{ color: isDarkMode ? '#10a37f' : '#10a37f' }} />,
            title: 'Personalized to you',
            desc: 'Can use memory and custom instructions to shape responses.'
          },
          {
            icon: <LockOutlined style={{ color: isDarkMode ? '#10a37f' : '#10a37f' }} />,
            title: "You're in control",
            desc: 'Audio recordings are saved, and you can delete them at any time.'
          }
        ].map((item, idx) => (
          <Stack key={idx} direction="row" spacing={2} alignItems="flex-start">
            <Box sx={{ mt: 0.5 }}>{item.icon}</Box>
            <Box>
              <Typography variant="subtitle2" fontWeight="bold" sx={{ color: isDarkMode ? 'white' : 'black' }}>{item.title}</Typography>
              <Typography variant="caption" sx={{ color: 'gray', lineHeight: 1.2 }}>{item.desc}</Typography>
            </Box>
          </Stack>
        ))}
      </Stack>

      <Box sx={{ mt: 'auto', pt: 4, textAlign: 'center' }}>
        <Typography variant="caption" sx={{ color: 'gray', display: 'block', mb: 3, px: 2 }}>
          SEFI can make mistakes – check important info. Usage limits may change.
        </Typography>
        <Button
          variant="contained"
          fullWidth
          onClick={handleContinueVoice}
          sx={{
            bgcolor: 'black',
            color: 'white',
            borderRadius: '25px',
            py: 1.5,
            textTransform: 'none',
            fontSize: '1rem',
            fontWeight: 'bold',
            '&:hover': { bgcolor: '#333' }
          }}
        >
          Continue
        </Button>
      </Box>
    </Box>
  );

  const TemporaryOnboarding = (
    <Box
      onClick={() => setShowTemporaryOnboarding(false)}
      sx={{
        position: 'absolute',
        inset: 0,
        zIndex: 300,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2,
        bgcolor: 'rgba(0,0,0,0.5)',
        backdropFilter: 'blur(4px)',
        cursor: 'pointer'
      }}
    >
      <Box
        onClick={(e) => e.stopPropagation()}
        sx={{
          width: '100%',
          maxWidth: 360,
          bgcolor: isDarkMode ? CHAT_GPT_DARK : '#ffffff',
          borderRadius: '24px',
          p: 3,
          pt: 4,
          boxShadow: '0 20px 40px rgba(0,0,0,0.3)',
          display: 'flex',
          flexDirection: 'column',
          position: 'relative',
          cursor: 'default'
        }}
      >
        <Typography variant="h6" fontWeight="bold" sx={{ mb: 3, color: isDarkMode ? 'white' : 'black' }}>
          Temporary Chat
        </Typography>

        <Stack spacing={3} sx={{ mb: 4 }}>
          {[
            {
              icon: <TemporaryChatIcon size={24} />,
              title: 'Not in history',
              desc: "Temporary chats won't appear in your history. For safety purposes, we may keep a copy of your chat for up to 30 days."
            },
            {
              icon: <NoTrainingIcon size={24} />,
              title: 'No model training',
              desc: "Temporary chats won't be used to improve our models."
            },
            {
              icon: <MemoryOffIcon size={24} />,
              title: 'Memory off',
              desc: "While in a temporary chat, SEFI won't use or update its memory. Custom instructions will still be followed if you have them enabled."
            }
          ].map((item, idx) => (
            <Stack key={idx} direction="row" spacing={2} alignItems="flex-start">
              <Box sx={{ color: isDarkMode ? 'white' : 'black', mt: 0.5 }}>{item.icon}</Box>
              <Box>
                <Typography variant="subtitle2" fontWeight="bold" sx={{ color: isDarkMode ? 'white' : 'black', fontSize: '1rem', mb: 0.2 }}>{item.title}</Typography>
                <Typography variant="caption" sx={{ color: isDarkMode ? 'rgba(255,255,255,0.6)' : '#666', fontSize: '0.85rem', lineHeight: 1.3, display: 'block' }}>{item.desc}</Typography>
              </Box>
            </Stack>
          ))}
        </Stack>

        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button
            variant="contained"
            onClick={handleContinueTemporary}
            sx={{
              bgcolor: isDarkMode ? 'white' : 'black',
              color: isDarkMode ? 'black' : 'white',
              borderRadius: '25px',
              px: 3,
              py: 0.8,
              textTransform: 'none',
              fontWeight: 'bold',
              fontSize: '0.9rem',
              '&:hover': { bgcolor: isDarkMode ? '#eee' : '#333' }
            }}
          >
            Continue
          </Button>
        </Box>
      </Box>
    </Box>
  );


  const ChatContent = (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', bgcolor: isDarkMode ? CHAT_GPT_LIGHT_DARK : '#ffffff', position: 'relative', overflow: 'hidden' }}>
      {maximized ? DesktopHeader : MobileHeader}

      {showVoiceOnboarding && VoiceOnboarding}
      {showTemporaryOnboarding && TemporaryOnboarding}

      <Box sx={{ display: 'flex', flex: 1, overflow: 'hidden', position: 'relative' }}>
        {/* Local Drawer for Small Window */}
        <AnimatePresence>
          {drawerOpen && (
            <>
              {/* Overlay for local drawer */}
              <Box
                component={motion.div}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                onClick={() => setDrawerOpen(false)}
                sx={{
                  position: 'absolute',
                  inset: 0,
                  bgcolor: 'rgba(0,0,0,0.5)',
                  zIndex: 100,
                  cursor: 'pointer'
                }}
              />
              {/* Drawer Content */}
              <Box
                component={motion.div}
                initial={{ x: '-100%' }}
                animate={{ x: 0 }}
                exit={{ x: '-100%' }}
                transition={{ type: 'spring', damping: 25, stiffness: 200 }}
                sx={{
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  bottom: 0,
                  width: 280,
                  bgcolor: isDarkMode ? CHAT_GPT_DARK : '#ffffff',
                  zIndex: 101,
                  boxShadow: '4px 0 12px rgba(0,0,0,0.1)'
                }}
              >
                {SidebarContent}
              </Box>
            </>
          )}
        </AnimatePresence>

        {maximized && desktopSidebarOpen && (
          <Box sx={{ width: 260, bgcolor: isDarkMode ? CHAT_GPT_DARK : '#ffffff', display: { xs: 'none', md: 'flex' }, flexDirection: 'column', borderRight: `1px solid ${isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)'}` }}>
            {SidebarContent}
          </Box>
        )}


        {maximized && !desktopSidebarOpen && SidebarSlim}

        <Box sx={{ 
          flex: 1, 
          display: 'flex', 
          flexDirection: 'column',
          justifyContent: (maximized && messages.length === 0) ? 'center' : 'flex-end',
          position: 'relative',
          overflow: 'hidden'
        }}>
          {/* Scroll Area for Messages or Mobile Suggestions */}
          <Box 
            ref={scrollRef} 
            sx={{ 
              flex: (maximized && messages.length === 0) ? 'none' : 1, 
              overflowY: 'auto',
              display: (maximized && messages.length === 0) ? 'none' : 'block'
            }}
          >
            {messages.length > 0 ? (
              messages.map(renderMessage)
            ) : (
              !maximized && (
                <Box sx={{ height: '100%', display: 'flex', flexDirection: 'column', p: 0 }}>
                  <Stack spacing={1} sx={{ mt: 'auto', mb: 1, px: 2 }}>
                    {(!isImageMode && !isWriteMode && !isSearchMode) && SUGGESTIONS.map((item, index) => (
                      <Box
                        key={index}
                        onClick={() => {
                          if (item.text === 'Create an image') {
                            setIsImageMode(true);
                            setIsWriteMode(false);
                            setIsSearchMode(false);
                          } else if (item.text === 'Write or edit') {
                            setIsWriteMode(true);
                            setIsImageMode(false);
                            setIsSearchMode(false);
                          } else if (item.text === 'Look something up') {
                            setIsSearchMode(true);
                            setIsImageMode(false);
                            setIsWriteMode(false);
                          } else {
                            setInput(item.text);
                          }
                        }}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1.5,
                          py: 0.5,
                          px: 1,
                          cursor: 'pointer',
                          color: isDarkMode ? 'rgba(255,255,255,0.6)' : '#555',
                          '&:hover': { color: isDarkMode ? '#fff' : '#000' }
                        }}
                      >
                        <Box sx={{ display: 'flex', opacity: 0.8 }}>{item.icon}</Box>
                        <Typography variant="body2" sx={{ fontSize: '0.85rem', fontWeight: 500 }}>{item.text}</Typography>
                      </Box>
                    ))}
                  </Stack>
                </Box>
              )
            )}
          </Box>

          {/* Banner & Input Container */}
          <Box sx={{ width: '100%' }}>
            {maximized && messages.length === 0 && (
              <Box sx={{ mb: 4, px: 4, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                {isTemporary ? (
                  <>
                    <Typography variant="h4" fontWeight="bold" sx={{ color: isDarkMode ? 'white' : 'black', mb: 1.5 }}>
                      Temporary Chat
                    </Typography>
                    <Typography variant="body2" sx={{ color: 'gray', maxWidth: 500, mx: 'auto', lineHeight: 1.6 }}>
                      This chat won't appear in your chat history, and won't be used to train our models.
                    </Typography>
                  </>
                ) : (isImageMode || isWriteMode || isSearchMode) ? (
                  <Typography variant="h4" fontWeight="500" sx={{ color: isDarkMode ? 'white' : 'black', mb: 1, letterSpacing: '-0.5px' }}>
                    What's on your mind today?
                  </Typography>
                ) : (
                  <>
                    <Box sx={{ width: 50, height: 50, mx: 'auto', mb: 2 }}>
                      <Lottie animationData={robotIcon} loop={true} />
                    </Box>
                    <Typography variant="h4" fontWeight="bold" sx={{ color: isDarkMode ? 'white' : 'black' }}>
                      How can I help you today?
                    </Typography>
                  </>
                )}
              </Box>
            )}

            <Box sx={{ p: 1, pb: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              {/* Image Mode Suggestions (Minimized View) */}
              {isImageMode && !maximized && messages.length === 0 && (
                <Box 
                  key="suggestions-mobile-image"
                  sx={{ 
                    bgcolor: isDarkMode ? '#2f2f2f' : '#f9f9f9',
                    borderRadius: '24px',
                    p: 1.5,
                    mb: 1,
                    width: '100%',
                    maxWidth: '340px',
                    mx: 'auto',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                  }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1.5, px: 1 }}>
                    <Typography variant="subtitle1" fontWeight="bold" sx={{ color: isDarkMode ? 'white' : 'black', fontSize: '0.95rem' }}>
                      Create an image
                    </Typography>
                    <Stack direction="row" spacing={0.2} alignItems="center">
                      <Typography variant="caption" sx={{ color: 'gray', mr: 0.5 }}>What's new</Typography>
                      <IconButton 
                        size="small" 
                        sx={{ color: 'gray', p: 0.2 }}
                        onClick={() => document.getElementById('mobile-scroll-container')?.scrollBy({ left: -150, behavior: 'smooth' })}
                      >
                        <ChevronLeft sx={{ fontSize: 18 }} />
                      </IconButton>
                      <IconButton 
                        size="small" 
                        sx={{ color: 'gray', p: 0.2 }}
                        onClick={() => document.getElementById('mobile-scroll-container')?.scrollBy({ left: 150, behavior: 'smooth' })}
                      >
                        <ChevronRight sx={{ fontSize: 18 }} />
                      </IconButton>
                    </Stack>
                  </Box>
                  <Box 
                    id="mobile-scroll-container"
                    ref={exploreScrollRefMobile}
                    sx={{ 
                      display: 'flex', 
                      gap: 1.2, 
                      overflowX: 'auto', 
                      pb: 0.5,
                      scrollbarWidth: 'none', 
                      '&::-webkit-scrollbar': { display: 'none' },
                    }}
                  >
                    <Box 
                      onClick={() => fileInputRef.current?.click()}
                      sx={{ 
                        flex: '0 0 130px',
                        borderRadius: '16px', 
                        bgcolor: isDarkMode ? 'rgba(255,255,255,0.03)' : '#f4f4f4',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        aspectRatio: '1/1',
                        cursor: 'pointer'
                      }}>
                      <Add sx={{ fontSize: 24, mb: 1, color: isDarkMode ? 'white' : 'black' }} />
                      <Typography sx={{ fontSize: '0.7rem', color: isDarkMode ? 'white' : 'black', textAlign: 'center' }}>Upload a photo</Typography>
                    </Box>
                    {[
                      { title: 'Improve Your Desk Setup', img: 'https://images.unsplash.com/photo-1493932484895-752d1471eab5?w=200&h=200&fit=crop' },
                      { title: 'Wanderlust', img: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=200&h=200&fit=crop' },
                      { title: 'Scribble', img: 'https://images.unsplash.com/photo-1513364776144-60967b0f800f?w=200&h=200&fit=crop' },
                      { title: 'Animal infographic', img: 'https://images.unsplash.com/photo-1546182990-dffeafbe841d?w=200&h=200&fit=crop' }
                    ].map((idea, i) => (
                      <Box key={i} sx={{ 
                        flex: '0 0 130px',
                        borderRadius: '16px', 
                        overflow: 'hidden', 
                        position: 'relative', 
                        aspectRatio: '1/1',
                        cursor: 'pointer'
                      }}>
                        <img src={idea.img} alt={idea.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        <Box sx={{ 
                          position: 'absolute', 
                          inset: 0, 
                          bgcolor: 'rgba(0,0,0,0.3)', 
                          display: 'flex', 
                          alignItems: 'flex-end', 
                          p: 1.2,
                          opacity: 0.9
                        }}>
                          <Typography variant="caption" sx={{ color: 'white', fontWeight: 'bold', fontSize: '0.7rem' }}>{idea.title}</Typography>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                </Box>
              )}

              {/* Search Mode Suggestions (Minimized View) */}
              {isSearchMode && !maximized && messages.length === 0 && (
                <Box 
                  key="suggestions-mobile-search"
                  sx={{ 
                    bgcolor: isDarkMode ? '#2f2f2f' : '#f9f9f9',
                    borderRadius: '24px',
                    p: 2,
                    mb: 1,
                    width: '100%',
                    maxWidth: '340px',
                    mx: 'auto',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                  }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography sx={{ color: isDarkMode ? 'white' : 'black', fontWeight: 600, fontSize: '0.95rem' }}>Look something up</Typography>
                    <IconButton size="small" onClick={() => setIsSearchMode(false)}>
                      <Close sx={{ fontSize: 18, color: 'gray' }} />
                    </IconButton>
                  </Box>
                  <Stack spacing={1.5}>
                    {['Petrol Price Today', 'Sslc Result 2026', 'Dhurandhar 2 Ott', 'Iran News'].map((text, i) => (
                      <Box 
                        key={i} 
                        onClick={() => setInput(text)}
                        sx={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          gap: 1.5, 
                          cursor: 'pointer', 
                          color: isDarkMode ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.7)', 
                          '&:hover': { color: isDarkMode ? 'white' : 'black' } 
                        }}>
                        <TrendingUp sx={{ fontSize: 18, opacity: 0.7 }} />
                        <Typography sx={{ fontSize: '0.9rem' }}>{text}</Typography>
                      </Box>
                    ))}
                  </Stack>
                </Box>
              )}

              {/* Write Mode Suggestions (Minimized View) */}
              {isWriteMode && !maximized && messages.length === 0 && (
                <Box 
                  key="suggestions-mobile-write"
                  sx={{ 
                    bgcolor: isDarkMode ? '#2f2f2f' : '#f9f9f9',
                    borderRadius: '24px',
                    p: 2,
                    mb: 1,
                    width: '100%',
                    maxWidth: '340px',
                    mx: 'auto',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.1)'
                  }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                    <Typography sx={{ color: isDarkMode ? 'white' : 'black', fontWeight: 600, fontSize: '0.95rem' }}>Write or edit</Typography>
                    <IconButton size="small" onClick={() => setIsWriteMode(false)}>
                      <Close sx={{ fontSize: 18, color: 'gray' }} />
                    </IconButton>
                  </Box>
                  <Stack spacing={1.5}>
                    {[
                      'Simplify my wording',
                      'Shorten without losing meaning',
                      'Proofread my writing',
                      'Expand with more detail'
                    ].map((text, i) => (
                      <Box 
                        key={i} 
                        onClick={() => setInput(text)}
                        sx={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          gap: 1.5, 
                          cursor: 'pointer', 
                          color: isDarkMode ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.7)', 
                          '&:hover': { color: isDarkMode ? 'white' : 'black' } 
                        }}>
                        <Edit sx={{ fontSize: 18, opacity: 0.7 }} />
                        <Typography sx={{ fontSize: '0.9rem' }}>{text}</Typography>
                      </Box>
                    ))}
                  </Stack>
                </Box>
              )}
              <Box sx={{
                width: '100%',
                maxWidth: maximized ? 720 : '340px',
                mx: 'auto',
                bgcolor: isDarkMode ? (maximized ? 'rgba(255,255,255,0.05)' : '#2f2f2f') : '#f4f4f4',
                borderRadius: !maximized ? '24px' : ((isImageMode || isSearchMode) ? '28px' : '32px'),
                p: !maximized ? 1.5 : 1.2,
                border: isImageMode && maximized ? (isDarkMode ? '1px solid rgba(255,255,255,0.2)' : '1px solid rgba(0,0,0,0.1)') : 'none',
                boxShadow: !maximized ? '0 4px 12px rgba(0,0,0,0.1)' : (isImageMode ? '0 4px 20px rgba(0,0,0,0.08)' : 'none'),
                position: 'relative',
                mb: !maximized ? 1 : 0
              }}>
                
                {/* Stacked Layout (Modes) or Single Row Layout (Normal) */}
                <Box sx={{ 
                  display: 'flex', 
                  flexDirection: (isImageMode || isSearchMode) ? 'column' : 'row', 
                  alignItems: (isImageMode || isSearchMode) ? 'stretch' : 'center', 
                  flex: 1, 
                  gap: (isImageMode || isSearchMode) ? 1 : 0.5 
                }}>

                  <Menu
                    anchorEl={plusAnchor}
                    open={Boolean(plusAnchor)}
                    onClose={() => setPlusAnchor(null)}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    sx={{ zIndex: 2000 }}
                    PaperProps={{
                      sx: {
                        mt: 1.5,
                        borderRadius: '20px',
                        minWidth: 240,
                        bgcolor: isDarkMode ? '#2f2f2f' : 'white',
                        color: isDarkMode ? 'white' : 'black',
                        border: `1px solid ${isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)'}`,
                        boxShadow: '0 12px 48px rgba(0,0,0,0.15)',
                        overflow: 'hidden',
                        zIndex: 2000
                      }
                    }}
                  >
                    <Box sx={{ py: 0.5 }}>
                      {[
                        { 
                          icon: <AttachFile sx={{ fontSize: 18 }} />, 
                          text: 'Add photos & files', 
                          action: () => { 
                            setIsSelectingFile(true);
                            fileInputRef.current?.click(); 
                          } 
                        },
                        { 
                          icon: <History sx={{ fontSize: 18 }} />, 
                          text: 'Recent files', 
                          action: (e) => setRecentFilesAnchor(e.currentTarget), 
                          hasSub: true 
                        },
                        { type: 'divider' },
                        { icon: <Image sx={{ fontSize: 18 }} />, text: 'Create image', action: () => { setIsImageMode(true); setIsSearchMode(false); setIsWriteMode(false); } },
                        { icon: <Explore sx={{ fontSize: 18 }} />, text: 'Deep research', action: () => { setIsSearchMode(true); setIsImageMode(false); setIsWriteMode(false); } },
                        { icon: <Language sx={{ fontSize: 18 }} />, text: 'Web search', action: () => { setIsSearchMode(true); setIsImageMode(false); setIsWriteMode(false); } },
                        { icon: <MoreHoriz sx={{ fontSize: 18 }} />, text: 'More', action: () => {}, hasSub: true },
                        { type: 'divider' },
                        { icon: <FolderOpen sx={{ fontSize: 18 }} />, text: 'Projects', action: () => {}, hasSub: true },
                      ].map((item, idx) => {
                        if (item.type === 'divider') return <Divider key={idx} sx={{ my: 0.5, opacity: 0.5 }} />;
                        
                        return (
                          <MenuItem 
                            key={idx}
                            onClick={(e) => {
                              item.action(e);
                              if (!item.hasSub) {
                                setPlusAnchor(null);
                              }
                            }}
                            sx={{ 
                              py: 1.2, 
                              px: 2, 
                              display: 'flex',
                              justifyContent: 'space-between',
                              '&:hover': { bgcolor: isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }
                            }}
                          >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.8 }}>
                              {item.icon}
                              <Typography sx={{ fontSize: '0.85rem', fontWeight: 500 }}>{item.text}</Typography>
                            </Box>
                            {item.hasSub && <ChevronRight sx={{ fontSize: 16, color: 'gray' }} />}
                          </MenuItem>
                        );
                      })}
                    </Box>
                  </Menu>
                  
                  <Menu
                    anchorEl={recentFilesAnchor}
                    open={Boolean(recentFilesAnchor)}
                    onClose={() => setRecentFilesAnchor(null)}
                    anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                    transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                    sx={{ zIndex: 2100 }}
                    PaperProps={{
                      sx: {
                        ml: 1,
                        borderRadius: '16px',
                        minWidth: 220,
                        bgcolor: isDarkMode ? '#2f2f2f' : 'white',
                        color: isDarkMode ? 'white' : 'black',
                        border: `1px solid ${isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)'}`,
                        boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
                        zIndex: 2100
                      }
                    }}
                  >
                    <Box sx={{ px: 2, py: 1 }}>
                      <Typography sx={{ color: 'gray', fontSize: '0.75rem', fontWeight: 600 }}>RECENT FILES</Typography>
                    </Box>
                    {recentFiles.map((file, idx) => (
                      <MenuItem 
                        key={idx}
                        onClick={() => {
                          setSelectedFiles(prev => [...prev, { id: Date.now(), url: file.url, name: file.name, type: 'image/png' }]);
                          setRecentFilesAnchor(null);
                          setPlusAnchor(null);
                        }}
                        sx={{ 
                          py: 1, 
                          px: 2, 
                          gap: 1.5,
                          '&:hover': { bgcolor: isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)' }
                        }}
                      >
                        <Box 
                          component="img" 
                          src={file.url} 
                          sx={{ width: 24, height: 24, borderRadius: '4px', objectFit: 'cover' }} 
                        />
                        <Typography sx={{ fontSize: '0.85rem' }}>{file.name}</Typography>
                      </MenuItem>
                    ))}
                  </Menu>
                  
                  <Box sx={{ 
                    display: 'flex', 
                    flexDirection: maximized ? 'row' : 'column',
                    alignItems: maximized ? 'center' : 'flex-start',
                    flex: 1, 
                    gap: 1 
                  }}>
                    {selectedFiles.length > 0 && (
                      <Box sx={{ 
                        display: 'flex', 
                        flexWrap: 'wrap',
                        gap: 1.5, 
                        p: 1,
                        width: '100%'
                      }}>
                        {selectedFiles.map((file) => (
                          <Box key={file.id} sx={{ position: 'relative', width: 44, height: 44, flexShrink: 0 }}>
                            {file.url ? (
                              <Box 
                                component="img" 
                                src={file.url} 
                                sx={{ width: '100%', height: '100%', borderRadius: '8px', objectFit: 'cover', border: isDarkMode ? '1px solid rgba(255,255,255,0.1)' : '1px solid rgba(0,0,0,0.1)' }} 
                              />
                            ) : (
                              <Box sx={{ width: '100%', height: '100%', bgcolor: isDarkMode ? 'rgba(255,255,255,0.05)' : '#eee', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <AttachFile sx={{ fontSize: 16 }} />
                              </Box>
                            )}
                            <IconButton 
                              size="small" 
                              onClick={() => setSelectedFiles(prev => prev.filter(f => f.id !== file.id))}
                              sx={{ 
                                position: 'absolute', 
                                top: -6, 
                                right: -6, 
                                bgcolor: isDarkMode ? 'white' : 'black', 
                                color: isDarkMode ? 'black' : 'white', 
                                width: 18,
                                height: 18,
                                boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                                '&:hover': { bgcolor: isDarkMode ? '#eee' : '#333' } 
                              }}
                            >
                              <Close sx={{ fontSize: 10 }} />
                            </IconButton>
                          </Box>
                        ))}
                      </Box>
                    )}
                    
                    <Box sx={{ display: 'flex', alignItems: 'center', flex: 1, gap: 1 }}>
                      {(!isImageMode && !isSearchMode) && (
                        <Tooltip title="Add files and more" arrow>
                          <IconButton 
                            onClick={(e) => setPlusAnchor(e.currentTarget)}
                            size="small" 
                            sx={{ 
                              color: isDarkMode ? 'white' : 'gray',
                              '&:hover': { bgcolor: isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' }
                            }}
                          >
                            <Add fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      )}
                      
                        <InputBase
                          fullWidth
                          multiline
                          maxRows={8}
                          placeholder={isSearchMode ? "Search the web" : (isWriteMode ? "Write anything" : (isImageMode ? "Describe or edit an image" : "Ask anything"))}
                          value={input}
                          disabled={sendMessage}
                          onChange={(e) => setInput(e.target.value)}
                          onKeyDown={(e) => {
                            if (e.key === 'Backspace' && input === '' && (isImageMode || isSearchMode || isWriteMode)) {
                              setIsImageMode(false);
                              setIsSearchMode(false);
                              setIsWriteMode(false);
                            }
                            if (e.key === 'Enter' && !e.shiftKey) {
                              e.preventDefault();
                              handleSend();
                            }
                          }}
                          sx={{
                            ml: (maximized && (isImageMode || isSearchMode)) ? 0.5 : 1,
                            px: (maximized && (isImageMode || isSearchMode)) ? 0.5 : 0,
                            color: isDarkMode ? 'white' : 'black',
                            fontSize: '1.05rem',
                            flex: 1,
                            '& .MuiInputBase-input::placeholder': {
                              color: isDarkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)',
                              opacity: 1
                            }
                          }}
                        />
                      </Box>
                    </Box>

                  {(!isImageMode && !isSearchMode) && (
                    <Stack direction="row" spacing={1} alignItems="center">
                      {!input.trim() && (
                        <Stack direction="row" spacing={0.5} alignItems="center">
                          <IconButton size="small" sx={{ color: isDarkMode ? 'white' : 'gray' }}>
                            <Mic fontSize="small" />
                          </IconButton>
                          {!isTemporary && (
                            sendMessage ? (
                              <CircularProgress size={24} sx={{ color: isDarkMode ? 'white' : 'gray' }} />
                            ) : (
                              <IconButton 
                                onClick={handleMicClick} 
                                size="small" 
                                sx={{ 
                                  bgcolor: '#000',
                                  color: '#fff',
                                  width: 34,
                                  height: 34,
                                  '&:hover': { bgcolor: '#333' }
                                }}
                              >
                                <VoiceWaveIcon size={22} color="white" />
                              </IconButton>
                            )
                          )}
                        </Stack>
                      )}
                       {(input.trim() || selectedFiles.length > 0 || maximized) && (
                        <IconButton
                          onClick={handleSend}
                          disabled={!input.trim() && selectedFiles.length === 0}
                          sx={{
                            bgcolor: input.trim() ? (isDarkMode ? 'white' : 'black') : 'transparent',
                            color: input.trim() ? (isDarkMode ? 'black' : 'white') : 'gray',
                            width: 32,
                            height: 32,
                            '&:hover': { bgcolor: input.trim() ? (isDarkMode ? '#eee' : '#333') : 'transparent' }
                          }}
                        >
                          <ArrowUpward sx={{ fontSize: 20 }} />
                        </IconButton>
                      )}
                    </Stack>
                  )}
                </Box>

                {/* Bottom Row (For Image or Search Mode) - Enabled for all views for mobile consistency */}
                {(isImageMode || isSearchMode) && (
                  <Box sx={{ 
                    display: 'flex', 
                    justifyContent: 'space-between', 
                    alignItems: 'center',
                    mt: maximized ? 1.5 : 1,
                    px: maximized ? 0.5 : 0
                  }}>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <IconButton 
                        onClick={() => {
                          setIsSelectingFile(true);
                          fileInputRef.current?.click();
                        }}
                        size="small" 
                        sx={{ color: isDarkMode ? 'white' : 'gray' }}
                      >
                        <Add fontSize="small" />
                      </IconButton>
                      
                      {isImageMode && (
                        <>
                          <Box 
                            onClick={() => setIsImageMode(false)}
                            onMouseEnter={() => setHoverImage(true)}
                            onMouseLeave={() => setHoverImage(false)}
                            sx={{ 
                              display: 'flex', 
                              alignItems: 'center', 
                              gap: 0.8, 
                              px: 1.2, 
                              py: 0.6, 
                              borderRadius: '20px', 
                              color: '#3498db', 
                              cursor: 'pointer', 
                              bgcolor: isDarkMode ? 'rgba(52,152,219,0.1)' : 'rgba(52,152,219,0.05)',
                              transition: 'all 0.2s',
                              '&:hover': { bgcolor: isDarkMode ? 'rgba(52,152,219,0.15)' : 'rgba(52,152,219,0.1)' }
                            }}
                          >
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 18, height: 18 }}>
                              {hoverImage ? (
                                <Box sx={{ bgcolor: isDarkMode ? 'rgba(52,152,219,0.2)' : 'rgba(52,152,219,0.1)', borderRadius: '50%', p: 0.2, display: 'flex' }}>
                                  <Close sx={{ fontSize: 14 }} />
                                </Box>
                              ) : (
                                <Image sx={{ fontSize: 16 }} />
                              )}
                            </Box>
                            <Typography sx={{ fontSize: '0.8rem', fontWeight: 600 }}>Image</Typography>
                          </Box>
                          <Box 
                            onClick={(e) => setAspectRatioAnchor(e.currentTarget)}
                            sx={{ display: 'flex', alignItems: 'center', gap: 0.5, px: 1, py: 0.5, borderRadius: '12px', border: 'none', color: isDarkMode ? 'white' : 'black', cursor: 'pointer', transition: 'all 0.2s', '&:hover': { bgcolor: isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.03)' } }}>
                            <AutoAwesome sx={{ fontSize: 16 }} />
                            <Typography sx={{ fontSize: '0.75rem', fontWeight: 600 }}>{selectedRatio}</Typography>
                            <KeyboardArrowDown sx={{ fontSize: 14 }} />
                          </Box>
                          <Menu
                            anchorEl={aspectRatioAnchor}
                            open={Boolean(aspectRatioAnchor)}
                            onClose={() => setAspectRatioAnchor(null)}
                            sx={{ zIndex: 2500 }}
                            PaperProps={{
                              sx: {
                                mt: 1,
                                borderRadius: '16px',
                                minWidth: 200,
                                bgcolor: isDarkMode ? '#2f2f2f' : 'white',
                                color: isDarkMode ? 'white' : 'black',
                                border: `1px solid ${isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}`,
                                boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
                                zIndex: 2500
                              }
                            }}
                          >
                            <Box sx={{ px: 2, py: 1.5 }}>
                              <Typography sx={{ color: 'gray', fontSize: '0.85rem' }}>Choose image aspect ratio</Typography>
                            </Box>
                            {[
                              { label: 'Auto', sub: '', icon: <AutoAwesome fontSize="small" /> },
                              { label: 'Square', sub: '1:1', icon: <CropSquare fontSize="small" /> },
                              { label: 'Portrait', sub: '3:4', icon: <CropPortrait fontSize="small" /> },
                              { label: 'Story', sub: '9:16', icon: <StayCurrentPortrait fontSize="small" /> },
                              { label: 'Landscape', sub: '4:3', icon: <CropLandscape fontSize="small" /> },
                              { label: 'Widescreen', sub: '16:9', icon: <Crop75 fontSize="small" /> },
                            ].map((ratio) => (
                              <MenuItem 
                                key={ratio.label}
                                onClick={() => {
                                  setSelectedRatio(ratio.label);
                                  setAspectRatioAnchor(null);
                                }}
                                sx={{ 
                                  py: 1, 
                                  px: 2, 
                                  display: 'flex', 
                                  justifyContent: 'space-between',
                                  '&:hover': { bgcolor: isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)' }
                                }}
                              >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                  {ratio.icon}
                                  <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 0.5 }}>
                                    <Typography sx={{ fontSize: '0.9rem', fontWeight: 500 }}>{ratio.label}</Typography>
                                    <Typography sx={{ fontSize: '0.75rem', color: 'gray' }}>{ratio.sub}</Typography>
                                  </Box>
                                </Box>
                                {selectedRatio === ratio.label && <Check sx={{ fontSize: 16 }} />}
                              </MenuItem>
                            ))}
                          </Menu>
                        </>
                      )}

                      {isSearchMode && (
                        <Box 
                          onClick={() => setIsSearchMode(false)}
                          onMouseEnter={() => setHoverSearch(true)}
                          onMouseLeave={() => setHoverSearch(false)}
                          sx={{ 
                            display: 'flex', 
                            alignItems: 'center', 
                            gap: 0.8, 
                            px: 1.2, 
                            py: 0.6, 
                            borderRadius: '20px', 
                            color: '#007aff', 
                            cursor: 'pointer', 
                            bgcolor: isDarkMode ? 'rgba(0,122,255,0.1)' : 'rgba(0,122,255,0.05)',
                            transition: 'all 0.2s',
                            '&:hover': { bgcolor: isDarkMode ? 'rgba(0,122,255,0.15)' : 'rgba(0,122,255,0.1)' }
                          }}
                        >
                          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: 18, height: 18 }}>
                            {hoverSearch ? (
                              <Box sx={{ bgcolor: isDarkMode ? 'rgba(0,122,255,0.2)' : 'rgba(0,122,255,0.1)', borderRadius: '50%', p: 0.2, display: 'flex' }}>
                                <Close sx={{ fontSize: 14 }} />
                              </Box>
                            ) : (
                              <Language sx={{ fontSize: 16 }} />
                            )}
                          </Box>
                          <Typography sx={{ fontSize: '0.8rem', fontWeight: 600 }}>Search</Typography>
                        </Box>
                      )}
                    </Stack>

                    <Stack direction="row" spacing={maximized ? 1.5 : 0.8} alignItems="center">
                      {maximized && (
                        <Tooltip title={<Typography sx={{ fontSize: '0.75rem', py: 0.2, px: 0.5 }}>Select model</Typography>} arrow placement="top">
                          <Box 
                            onClick={(e) => setModelAnchor(e.currentTarget)}
                            sx={{ display: 'flex', alignItems: 'center', gap: 0.5, px: 1, py: 0.5, borderRadius: '12px', color: 'gray', bgcolor: 'transparent', cursor: 'pointer', transition: 'all 0.2s', '&:hover': { color: isDarkMode ? 'white' : 'black' } }}>
                            <Typography sx={{ fontSize: '0.85rem', fontWeight: 500 }}>{selectedModel}</Typography>
                            <KeyboardArrowDown sx={{ fontSize: 14 }} />
                          </Box>
                        </Tooltip>
                      )}
                      
                      {!input.trim() ? (
                        <>
                          <IconButton size="small" sx={{ color: isDarkMode ? 'white' : 'gray' }}>
                            <Mic fontSize="small" />
                          </IconButton>

                          <IconButton
                            onClick={handleMicClick}
                            sx={{
                              bgcolor: '#000',
                              color: '#fff',
                              width: maximized ? 42 : 36,
                              height: maximized ? 42 : 36,
                              border: isDarkMode ? '1px solid rgba(255,255,255,0.2)' : 'none',
                              '&:hover': { bgcolor: '#333' }
                            }}
                          >
                            <VoiceWaveIcon size={maximized ? 28 : 24} color="white" />
                          </IconButton>
                        </>
                      ) : (
                        <IconButton
                          onClick={handleSend}
                          sx={{
                            bgcolor: isDarkMode ? 'white' : 'black',
                            color: isDarkMode ? 'black' : 'white',
                            width: maximized ? 32 : 30,
                            height: maximized ? 32 : 30,
                            '&:hover': { bgcolor: isDarkMode ? '#eee' : '#333' }
                          }}
                        >
                          <ArrowUpward sx={{ fontSize: maximized ? 20 : 18 }} />
                        </IconButton>
                      )}
                    </Stack>
                  </Box>
                )}
              </Box>

              {maximized && messages.length === 0 && !isImageMode && !isWriteMode && !isSearchMode && (
                <Stack
                  direction="row"
                  justifyContent="center"
                  spacing={1.5}
                  sx={{ mt: 3 }}
                >
                  {[
                    { icon: <Image sx={{ fontSize: 18 }} />, text: 'Create an image' },
                    { icon: <Edit sx={{ fontSize: 18 }} />, text: 'Write or edit' },
                    { icon: <Language sx={{ fontSize: 18 }} />, text: 'Look something up' }
                  ].map((action, idx) => (
                    <Box
                      key={idx}
                      onClick={() => {
                        if (action.text === 'Create an image') {
                          setIsImageMode(true);
                          setIsWriteMode(false);
                        } else if (action.text === 'Write or edit') {
                          setIsWriteMode(true);
                          setIsImageMode(false);
                          setIsSearchMode(false);
                        } else if (action.text === 'Look something up') {
                          setIsSearchMode(true);
                          setIsImageMode(false);
                          setIsWriteMode(false);
                        } else {
                          setInput(action.text);
                          setIsImageMode(false);
                          setIsWriteMode(false);
                          setIsSearchMode(false);
                        }
                      }}
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        px: 2,
                        py: 0.8,
                        borderRadius: '20px',
                        border: `1px solid ${isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}`,
                        cursor: 'pointer',
                        color: isDarkMode ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.7)',
                        bgcolor: isDarkMode ? 'rgba(255,255,255,0.02)' : 'transparent',
                        transition: 'all 0.2s',
                        '&:hover': {
                          bgcolor: isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)',
                          borderColor: isDarkMode ? 'rgba(255,255,255,0.3)' : 'rgba(0,0,0,0.3)',
                          color: isDarkMode ? '#fff' : '#000'
                        }
                      }}
                    >
                      {action.icon}
                      <Typography variant="body2" sx={{ fontSize: '0.85rem' }}>{action.text}</Typography>
                    </Box>
                  ))}
                </Stack>
              )}

              {isWriteMode && maximized && (
                <Box sx={{ maxWidth: 720, mx: 'auto', mt: 2, width: '100%' }}>
                  <Stack spacing={0.5}>
                    {[
                      'Simplify my wording',
                      'Shorten without losing meaning',
                      'Proofread my writing',
                      'Expand with more detail'
                    ].map((text, i) => (
                      <Box 
                        key={i}
                        onClick={() => {
                          setInput(text);
                          setIsWriteMode(false);
                        }}
                        sx={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          gap: 1.5, 
                          px: 2, 
                          py: 1.2, 
                          borderRadius: '12px', 
                          cursor: 'pointer',
                          color: isDarkMode ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.7)',
                          transition: 'all 0.2s',
                          '&:hover': { 
                            bgcolor: isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)',
                            color: isDarkMode ? '#fff' : '#000'
                          } 
                        }}
                      >
                        <Edit sx={{ fontSize: 18, opacity: 0.7 }} />
                        <Typography sx={{ fontSize: '0.9rem' }}>{text}</Typography>
                      </Box>
                    ))}
                  </Stack>
                </Box>
              )}

              {isSearchMode && maximized && (
                <Box sx={{ maxWidth: 720, mx: 'auto', mt: 2, width: '100%' }}>
                  <Stack spacing={0.5}>
                    {[
                      'Petrol Price Today',
                      'Sslc Result 2026',
                      'Dhurandhar 2 Ott',
                      'Iran News'
                    ].map((text, i) => (
                      <Box 
                        key={i}
                        onClick={() => {
                          setInput(text);
                          setIsSearchMode(false);
                        }}
                        sx={{ 
                          display: 'flex', 
                          alignItems: 'center', 
                          gap: 1.5, 
                          px: 2, 
                          py: 1.2, 
                          borderRadius: '12px', 
                          cursor: 'pointer',
                          color: isDarkMode ? 'rgba(255,255,255,0.7)' : 'rgba(0,0,0,0.7)',
                          transition: 'all 0.2s',
                          '&:hover': { 
                            bgcolor: isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.05)',
                            color: isDarkMode ? '#fff' : '#000'
                          } 
                        }}
                      >
                        <TrendingUp sx={{ fontSize: 18, opacity: 0.7 }} />
                        <Typography sx={{ fontSize: '0.9rem' }}>{text}</Typography>
                      </Box>
                    ))}
                  </Stack>
                </Box>
              )}

              {isImageMode && messages.length === 0 && maximized && (
                <Box 
                  key="suggestions-desktop"
                  sx={{ mt: 6, width: '100%', maxWidth: 800, mx: 'auto' }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2, px: 1 }}>
                    <Typography variant="subtitle1" fontWeight="bold" sx={{ color: isDarkMode ? 'white' : 'black' }}>
                      Explore ideas
                    </Typography>
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Typography variant="caption" sx={{ color: 'gray', borderBottom: '1px dotted gray', cursor: 'pointer' }}>What's new</Typography>
                      <IconButton 
                        size="small" 
                        sx={{ color: 'gray' }}
                        onClick={() => document.getElementById('desktop-scroll-container')?.scrollBy({ left: -200, behavior: 'smooth' })}
                      >
                        <ChevronLeft />
                      </IconButton>
                      <IconButton 
                        size="small" 
                        sx={{ color: 'gray' }}
                        onClick={() => document.getElementById('desktop-scroll-container')?.scrollBy({ left: 200, behavior: 'smooth' })}
                      >
                        <ChevronRight />
                      </IconButton>
                    </Stack>
                  </Box>
                  <Box 
                    id="desktop-scroll-container"
                    ref={exploreScrollRefDesktop}
                    sx={{ 
                      display: 'flex', 
                      gap: 1.5, 
                      overflowX: 'auto', 
                      pb: 1,
                      scrollbarWidth: 'none', 
                      '&::-webkit-scrollbar': { display: 'none' },
                    }}
                  >
                    <Box 
                      onClick={() => fileInputRef.current?.click()}
                      sx={{ 
                        flex: '0 0 calc((100% - 60px) / 5.2)',
                        minWidth: '130px',
                        borderRadius: '16px', 
                        bgcolor: isDarkMode ? 'rgba(255,255,255,0.03)' : '#f4f4f4',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        aspectRatio: '1/1',
                        cursor: 'pointer',
                        border: isDarkMode ? '1px dashed rgba(255,255,255,0.1)' : '1px dashed rgba(0,0,0,0.1)',
                        '&:hover': { bgcolor: isDarkMode ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.03)' }
                      }}>
                      <Add sx={{ fontSize: 32, mb: 1, color: isDarkMode ? 'white' : 'black' }} />
                      <Typography sx={{ fontSize: '0.85rem', color: isDarkMode ? 'white' : 'black', fontWeight: 500 }}>Upload a photo</Typography>
                    </Box>
                    {[
                      { title: 'Improve Your Desk Setup', img: 'https://images.unsplash.com/photo-1493932484895-752d1471eab5?w=200&h=200&fit=crop' },
                      { title: 'Wanderlust', img: 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=200&h=200&fit=crop' },
                      { title: 'Scribble', img: 'https://images.unsplash.com/photo-1513364776144-60967b0f800f?w=200&h=200&fit=crop' },
                      { title: 'Animal infographic', img: 'https://images.unsplash.com/photo-1546182990-dffeafbe841d?w=200&h=200&fit=crop' },
                      { title: 'Architectural Marvels', img: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=200&h=200&fit=crop' }
                    ].map((idea, i) => (
                      <Box key={i} sx={{ 
                        flex: '0 0 calc((100% - 60px) / 5.2)',
                        minWidth: '130px',
                        borderRadius: '16px', 
                        overflow: 'hidden', 
                        position: 'relative', 
                        aspectRatio: '1/1',
                        cursor: 'pointer'
                      }}>
                        <img src={idea.img} alt={idea.title} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                        <Box sx={{ 
                          position: 'absolute', 
                          inset: 0, 
                          bgcolor: 'rgba(0,0,0,0.3)', 
                          display: 'flex', 
                          alignItems: 'flex-end', 
                          p: 1.5,
                          opacity: 0.8
                        }}>
                          <Typography variant="caption" sx={{ color: 'white', fontWeight: 'bold', fontSize: '0.75rem' }}>{idea.title}</Typography>
                        </Box>
                      </Box>
                    ))}
                  </Box>
                </Box>
              )}

              {isTemporary && !maximized && (
                <Typography
                  variant="caption"
                  sx={{
                    display: 'block',
                    textAlign: 'center',
                    mt: 1,
                    mb: 2,
                    color: isDarkMode ? 'rgba(255,255,255,0.5)' : 'gray',
                    fontSize: '0.65rem'
                  }}
                >
                  For safety, we may keep a copy of this chat for upto 30 days.
                </Typography>
              )}
          </Box>
          {isTemporary && maximized && (
            <Typography
              variant="caption"
              sx={{
                position: 'absolute',
                bottom: 8,
                left: 0,
                right: 0,
                textAlign: 'center',
                color: isDarkMode ? 'rgba(255,255,255,0.5)' : 'gray',
                fontSize: '0.7rem',
                zIndex: 10
              }}
            >
              For safety, we may keep a copy of this chat for upto 30 days.
            </Typography>
          )}
        </Box>
      </Box>
    </Box>
  </Box>
);

  const ModelSelectorMenu = (
    <Menu
      anchorEl={modelAnchor}
      open={Boolean(modelAnchor)}
      onClose={() => setModelAnchor(null)}
      PaperProps={{
        sx: {
          mt: 1,
          borderRadius: '16px',
          minWidth: 160,
          bgcolor: isDarkMode ? '#2f2f2f' : 'white',
          color: isDarkMode ? 'white' : 'black',
          border: `1px solid ${isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)'}`,
          boxShadow: '0 8px 32px rgba(0,0,0,0.2)'
        }
      }}
    >
      <Box sx={{ px: 2, py: 1 }}>
        <Typography sx={{ color: 'gray', fontSize: '0.75rem' }}>Latest • 5.5</Typography>
      </Box>
      {['Instant', 'Thinking'].map((model) => (
        <MenuItem 
          key={model}
          onClick={() => {
            setSelectedModel(model);
            setModelAnchor(null);
          }}
          sx={{ 
            py: 1, 
            px: 2, 
            display: 'flex', 
            justifyContent: 'space-between',
            '&:hover': { bgcolor: isDarkMode ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.02)' }
          }}
        >
          <Typography sx={{ fontSize: '0.9rem', fontWeight: 500 }}>{model}</Typography>
          {selectedModel === model && <Check sx={{ fontSize: 16 }} />}
        </MenuItem>
      ))}
    </Menu>
  );

  const SearchModalContent = (
    <Box sx={{ p: 1, display: 'flex', flexDirection: 'column', height: '100%', bgcolor: isDarkMode ? '#2f2f2f' : '#ffffff' }}>
      {/* Header */}
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'center', 
        px: 2, 
        py: maximized ? 2 : 1.5,
        borderBottom: `1px solid ${isDarkMode ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.06)'}`
      }}>
        <InputBase
          autoFocus
          placeholder="Search chats..."
          value={searchModalQuery}
          onChange={(e) => setSearchModalQuery(e.target.value)}
          sx={{
            flex: 1,
            fontSize: maximized ? '1.1rem' : '1rem',
            color: isDarkMode ? 'white' : 'black',
            '& .MuiInputBase-input::placeholder': {
              color: isDarkMode ? 'rgba(255,255,255,0.35)' : 'rgba(0,0,0,0.35)',
              opacity: 1
            }
          }}
        />
        <IconButton size="small" onClick={() => setSearchDialogOpen(false)} sx={{ color: 'gray', opacity: 0.7 }}>
          <Close />
        </IconButton>
      </Box>

      {/* List Area */}
      <Box sx={{ 
        flex: 1, 
        overflowY: 'auto', 
        p: maximized ? 2 : 1.5,
        /* Custom Thin Scrollbar */
        '&::-webkit-scrollbar': { width: '4px' },
        '&::-webkit-scrollbar-thumb': { 
          bgcolor: isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)',
          borderRadius: '10px'
        }
      }}>
        {/* New Chat Button (Mobile Style) */}
        <Button
          variant="text"
          startIcon={<Edit fontSize="small" />}
          fullWidth
          onClick={() => {
            handleNewChat();
            setSearchDialogOpen(false);
          }}
          sx={{
            justifyContent: 'flex-start',
            bgcolor: isDarkMode ? 'rgba(255,255,255,0.03)' : 'rgba(0,0,0,0.03)',
            color: isDarkMode ? 'white' : 'black',
            mb: 3,
            borderRadius: '12px',
            py: 1.5,
            px: 2,
            textTransform: 'none',
            fontWeight: 600,
            '&:hover': { bgcolor: isDarkMode ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.05)' }
          }}
        >
          New chat
        </Button>

        <Box sx={{ mb: 3 }}>
          <Typography variant="caption" sx={{ color: isDarkMode ? 'rgba(255,255,255,0.4)' : 'rgba(0,0,0,0.4)', fontWeight: 600, ml: 1, mb: 1, display: 'block', fontSize: '0.75rem' }}>
            Recents
          </Typography>
          <Stack spacing={0.5}>
            {historyLoading && (
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
                <CircularProgress size={22} />
              </Box>
            )}
            {!historyLoading && history
              .filter(item => item.title.toLowerCase().includes(searchModalQuery.toLowerCase()))
              .map((item) => (
                <Box
                  key={item.id}
                  onClick={() => {
                    handleLoadChat(item);
                    setSearchDialogOpen(false);
                  }}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 2,
                    px: 1.5,
                    py: 1.2,
                    borderRadius: '12px',
                    cursor: 'pointer',
                    transition: 'all 0.15s',
                    color: isDarkMode ? 'rgba(255,255,255,0.9)' : 'rgba(0,0,0,0.8)',
                    bgcolor: currentChatId === item.id ? (isDarkMode ? 'rgba(255,255,255,0.06)' : 'rgba(0,0,0,0.04)') : 'transparent',
                    '&:hover': { bgcolor: isDarkMode ? 'rgba(255,255,255,0.04)' : 'rgba(0,0,0,0.02)' }
                  }}
                >
                  <ChatBubbleOutline sx={{ fontSize: 20, color: isDarkMode ? 'rgba(255,255,255,0.5)' : 'rgba(0,0,0,0.3)' }} />
                  <Typography sx={{ fontSize: maximized ? '0.95rem' : '0.9rem', fontWeight: 500, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>
                    {item.title}
                  </Typography>
                </Box>
              ))}
            {!historyLoading && history.filter(item => item.title.toLowerCase().includes(searchModalQuery.toLowerCase())).length === 0 && (
              <Typography align="center" sx={{ color: 'gray', py: 2, fontSize: '0.85rem' }}>
                {history.length === 0 ? 'No chats yet' : 'No conversations found'}
              </Typography>
            )}
          </Stack>
        </Box>

        <Box />
      </Box>
    </Box>
  );

  return (
    <>
      <AnimatePresence>
        {open && !maximized && (
          <ClickAwayListener onClickAway={(e) => {
            if (isSelectingFile) return;
            // Additional check for mobile focus shifts
            if (document.activeElement?.type === 'file') return;
            onClose(e);
          }}>
            <Box
              component={motion.div}
              initial={{ opacity: 0, y: 20, scale: 0.95 }}
              animate={{ opacity: 1, y: 0, scale: 1 }}
              exit={{ opacity: 0, y: 20, scale: 0.95 }}
              sx={{
                position: 'fixed',
                bottom: 20,
                right: 20,
                width: { xs: 'calc(100% - 40px)', sm: 400 },
                height: 600,
                zIndex: 1400,
                borderRadius: '20px',
                overflow: 'hidden',
                boxShadow: '0 12px 48px rgba(0,0,0,0.2)',
                border: `1px solid ${isDarkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.05)'}`,
                display: 'flex',
                flexDirection: 'column'
              }}
            >
              {searchDialogOpen ? (
                <Box sx={{ flex: 1, position: 'relative', overflow: 'hidden' }}>
                  {SearchModalContent}
                </Box>
              ) : ChatContent}
              <input 
                type="file" 
                hidden 
                multiple
                ref={fileInputRef} 
                accept="image/*,.pdf,.doc,.docx,.txt" 
                onChange={handleFileChange} 
              />
            </Box>
          </ClickAwayListener>
        )}
      </AnimatePresence>

      <Dialog
        fullScreen
        open={open && maximized}
        onClose={onClose}
        TransitionComponent={Zoom}
      >
        <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
          {ChatContent}
          {/* Search Dialog for Maximized Mode */}
          <Dialog
            open={searchDialogOpen && maximized}
            onClose={() => setSearchDialogOpen(false)}
            maxWidth="sm"
            fullWidth
            scroll="paper"
            sx={{
              '& .MuiDialog-container': {
                alignItems: 'flex-start',
                pt: { xs: 5, md: 10 }
              }
            }}
            PaperProps={{
              sx: {
                borderRadius: '16px',
                bgcolor: isDarkMode ? '#2f2f2f' : '#ffffff',
                backgroundImage: 'none',
                overflow: 'hidden',
                boxShadow: '0 24px 64px rgba(0,0,0,0.2)',
                maxHeight: '70vh'
              }
            }}
          >
            {SearchModalContent}
          </Dialog>
        </Box>
      </Dialog>
      <Dialog
        fullScreen
        open={Boolean(previewImage)}
        onClose={() => setPreviewImage(null)}
        sx={{ 
          '& .MuiDialog-paper': { 
            bgcolor: 'rgba(0,0,0,0.95)', 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            position: 'relative'
          } 
        }}
      >
        <IconButton 
          onClick={() => setPreviewImage(null)}
          sx={{ position: 'absolute', top: 20, right: 20, color: 'white' }}
        >
          <Close />
        </IconButton>
        <Box 
          component="img" 
          src={previewImage} 
          sx={{ maxWidth: '95%', maxHeight: '95%', objectFit: 'contain', borderRadius: '8px' }} 
        />
      </Dialog>
      {ModelSelectorMenu}

    </>
  );
}
